import { render, staticRenderFns } from "./ReportCheckBlackList.vue?vue&type=template&id=648588d4&scoped=true&"
import script from "./ReportCheckBlackList.vue?vue&type=script&lang=js&"
export * from "./ReportCheckBlackList.vue?vue&type=script&lang=js&"
import style0 from "./ReportCheckBlackList.vue?vue&type=style&index=0&id=648588d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648588d4",
  null
  
)

export default component.exports